var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row marketing" }, [
      _c("div", { staticClass: "col-lg-3" }, [
        _c("h4", { staticClass: "form-head" }, [
          _vm._v("\n        New User\n      ")
        ]),
        _vm._v(" "),
        _c("form", { attrs: { action: "", name: "cform" } }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "name" } }, [_vm._v("Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.f.name,
                  expression: "f.name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "name", required: "" },
              domProps: { value: _vm.f.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.f, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "exampleInputEmail0" } }, [
              _vm._v("User ID")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.f.userName,
                  expression: "f.userName"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "exampleInputEmail0", required: "" },
              domProps: { value: _vm.f.userName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.f, "userName", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "exampleInputEmail1" } }, [
              _vm._v("Password")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.f.password,
                  expression: "f.password"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "password",
                id: "exampleInputEmail1",
                required: ""
              },
              domProps: { value: _vm.f.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.f, "password", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "email" } }, [_vm._v("EMail")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.f.email,
                  expression: "f.email"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "email", id: "email", required: "" },
              domProps: { value: _vm.f.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.f, "email", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "tel" } }, [_vm._v("Mobile")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.f.mobile,
                  expression: "f.mobile"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "tel", id: "tel" },
              domProps: { value: _vm.f.mobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.f, "mobile", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          !_vm.localAdmin
            ? _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.f.admin,
                      expression: "f.admin"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "isAdmin" },
                  domProps: {
                    checked: Array.isArray(_vm.f.admin)
                      ? _vm._i(_vm.f.admin, null) > -1
                      : _vm.f.admin
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.f.admin,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && _vm.$set(_vm.f, "admin", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.f,
                              "admin",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.f, "admin", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "isAdmin" }
                  },
                  [_vm._v("is Admin?")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.f.admin && !_vm.localAdmin
            ? _c("div", { staticClass: "form-check mt-3 mb-3" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.f.localAdmin,
                      expression: "f.localAdmin"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "localAdmin" },
                  domProps: {
                    checked: Array.isArray(_vm.f.localAdmin)
                      ? _vm._i(_vm.f.localAdmin, null) > -1
                      : _vm.f.localAdmin
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.f.localAdmin,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.f, "localAdmin", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.f,
                              "localAdmin",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.f, "localAdmin", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "localAdmin" }
                  },
                  [_vm._v("is Local Admin?")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.f.admin && _vm.ewbTenant
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "exampleInputEmail4" } }, [
                  _vm._v("Permissions")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.f.permissions,
                        expression: "f.permissions"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { multiple: "", id: "exampleInputEmail4" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.f,
                          "permissions",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "CREATE_EWB" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.description("CREATE_EWB")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "UPDATE_EWB" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.description("CREATE_EWB")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "CANCEL_EWB" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.description("CANCEL_EWB")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "EXTEND_EWB" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.description("EXTEND_EWB")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "REJECT_EWB" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.description("REJECT_EWB")) +
                          "\n            "
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.f.admin && _vm.podTenant
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "ut" } }, [_vm._v("User Type")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.f.whomType,
                        expression: "f.whomType"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { id: "ut" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.f,
                          "whomType",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "REGULAR_USER" } }, [
                      _vm._v("\n              Company User\n            ")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "TRANSPORTER" } }, [
                      _vm._v("\n              Transporter\n            ")
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.f.admin && _vm.ewbTenant
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "exampleInputEmail5" } }, [
                  _vm._v("Allowed States")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.f.creds,
                        expression: "f.creds"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { multiple: "", id: "exampleInputEmail5" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.f,
                          "creds",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.creds, function(c) {
                    return _c(
                      "option",
                      { key: c.id, domProps: { value: c.id } },
                      [
                        _vm._v(
                          _vm._s(c.state) + " – (" + _vm._s(c.gstNumber) + ")"
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.f.admin && _vm.podTenant
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "allLocations" } }, [
                  _vm._v("Allow ALL Locations?")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.f.allLocations,
                        expression: "f.allLocations"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { id: "allLocations" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.f,
                          "allLocations",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: true } }, [
                      _vm._v("Yes")
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: false } }, [_vm._v("No")])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.podTenant &&
          !_vm.f.admin &&
          _vm.f.whomType !== "TRANSPORTER" &&
          _vm.f.allLocations === false
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "loca" } }, [
                  _vm._v("Allowed Locations")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.f.locations,
                        expression: "f.locations"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { multiple: "", id: "loca" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.f,
                          "locations",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.locations, function(c) {
                    return _c(
                      "option",
                      { key: c.id, domProps: { value: c.id } },
                      [_vm._v(_vm._s(c.name))]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.f.admin && _vm.f.whomType === "TRANSPORTER"
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "tr" } }, [
                  _vm._v("Assign Transporter")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.f.transporters,
                        expression: "f.transporters"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { id: "tr", multiple: "true" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.f,
                          "transporters",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.transporters, function(c) {
                    return _c(
                      "option",
                      { key: c.id, domProps: { value: c.id } },
                      [_vm._v(_vm._s(c.name))]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.saveUser()
                }
              }
            },
            [_vm._v("\n          Save\n        ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-9" }, [
        _c("h4", { staticClass: "form-head" }, [
          _vm._v("\n        Existing Users\n      ")
        ]),
        _vm._v(" "),
        _vm.ewbTenant
          ? _c("table", { staticClass: "table" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.users, function(u) {
                  return _c("tr", { key: u.id }, [
                    _c("td", [_vm._v(_vm._s(u.name))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(u.userName))]),
                    _vm._v(" "),
                    !u.admin
                      ? _c("td", [
                          _c(
                            "ul",
                            {
                              staticClass: "list-group",
                              staticStyle: { "font-size": "small" }
                            },
                            _vm._l(u.permissions, function(l) {
                              return _c(
                                "li",
                                { key: l, staticClass: "list-group-item" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.description(l)) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !u.admin
                      ? _c("td", [
                          _c(
                            "ul",
                            {
                              staticClass: "list-group",
                              staticStyle: { "font-size": "small" }
                            },
                            _vm._l(u.creds, function(l) {
                              return _c(
                                "li",
                                { key: l, staticClass: "list-group-item" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.cred(l)) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    u.admin
                      ? _c("td", { attrs: { colspan: "2" } }, [
                          _vm._v("\n            Administrator\n          ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          on: {
                            click: function($event) {
                              return _vm.editUser(u)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-pencil" })]
                      )
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.podTenant
          ? _c(
              "div",
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-content-center align-items-center"
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("b-form-input", {
                            model: {
                              value: _vm.us,
                              callback: function($$v) {
                                _vm.us = $$v
                              },
                              expression: "us"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("b-button", { on: { click: _vm.searchUs } }, [
                            _vm._v("Search")
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-fill justify-content-end align-content-center align-items-center"
                    },
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.rows,
                          "per-page": _vm.perPage,
                          "aria-controls": "my-table"
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "mt-3" }, [
                        _vm._v("Current Page: " + _vm._s(_vm.currentPage))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    id: "my-table",
                    items: _vm.fusers,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                    fields: _vm.fields,
                    small: ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(admin)",
                        fn: function(data) {
                          return [
                            _c("div", [
                              data.item.admin
                                ? _c("span", [_vm._v("Administrator")])
                                : _vm._e(),
                              _vm._v(" "),
                              data.item.localAdmin
                                ? _c("span", [_vm._v("Local Administrator")])
                                : _vm._e(),
                              _vm._v(" "),
                              !data.item.admin &&
                              data.item.whomType === "REGULAR_USER" &&
                              !data.item.admin &&
                              !data.item.localAdmin
                                ? _c("span", [_vm._v("Company User")])
                                : _vm._e(),
                              _vm._v(" "),
                              !data.item.admin &&
                              data.item.whomType === "TRANSPORTER"
                                ? _c("span", [_vm._v("Transporter")])
                                : _vm._e()
                            ])
                          ]
                        }
                      },
                      {
                        key: "cell(locations)",
                        fn: function(data) {
                          return [
                            _c("div", [
                              !data.item.admin &&
                              data.item.whomType !== "TRANSPORTER" &&
                              (data.item.allLocations === false ||
                                !data.item.allLocations)
                                ? _c(
                                    "ul",
                                    { staticClass: "list-unstyled" },
                                    _vm._l(data.item.locations, function(l) {
                                      return _c("li", { key: l }, [
                                        _vm.locationMap[l]
                                          ? _c("span", [
                                              _c("i", {
                                                staticClass: "fa fa-warehouse"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.locationMap[l].name
                                                  )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              data.item.admin || data.item.allLocations
                                ? _c("span", [_vm._v("All Locations")])
                                : _vm._e(),
                              _vm._v(" "),
                              data.item.whomType === "TRANSPORTER"
                                ? _c("div", [
                                    data.item.whom
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-truck"
                                          }),
                                          _vm._v(
                                            " " + _vm._s(data.item.whom.name)
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.item.transporters
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex flex-column" },
                                          _vm._l(
                                            data.item.transporters,
                                            function(t) {
                                              return _c("span", { key: t }, [
                                                _c("i", {
                                                  staticClass: "fa fa-truck"
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.transportersMap[t]
                                                        .name
                                                    )
                                                )
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ])
                          ]
                        }
                      },
                      {
                        key: "cell(edit)",
                        fn: function(data) {
                          return [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "btn btn-primary btn-sm",
                                attrs: { title: "Edit User" },
                                on: {
                                  click: function($event) {
                                    return _vm.editUser(data.item)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-pencil" })]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2334986083
                  )
                })
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-dark" }, [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("User ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Permissions")]),
        _vm._v(" "),
        _c("th", [_vm._v("States")]),
        _vm._v(" "),
        _c("th", [_vm._v(" ")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70df762c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70df762c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/UserPage.vue
// module id = null
// module chunks = 